import React from 'react';
import { Autocomplete, Box, Button, TextField } from '@mui/material';

function FilterSelect({ label, options, value, onChange, sx }) {
  const choices = options || [];
  const optionsWithValue = value && !choices.includes(value) ? [value, ...choices] : choices;
  return (
    <Autocomplete
      size="small"
      options={optionsWithValue}
      value={value || null}
      onChange={(_, next) => onChange(next || '')}
      sx={{ minWidth: 180, ...sx }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
}

export default function RawDataFilterBar({
  query,
  onQueryChange,
  brand,
  category,
  retailer,
  day,
  onBrandChange,
  onCategoryChange,
  onRetailerChange,
  onDayChange,
  facets,
  onClear,
}) {
  const hasFilter = Boolean(query || brand || category || retailer || day);
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2, alignItems: 'center' }}>
      <TextField
        size="small"
        label="Search"
        placeholder="Title, brand, EAN, retailer"
        value={query}
        onChange={(event) => onQueryChange(event.target.value)}
        sx={{ minWidth: 240 }}
      />
      <FilterSelect label="Brand" options={facets?.brands} value={brand} onChange={onBrandChange} />
      <FilterSelect label="Category" options={facets?.categories} value={category} onChange={onCategoryChange} />
      <FilterSelect label="Retailer" options={facets?.retailers} value={retailer} onChange={onRetailerChange} />
      <FilterSelect label="Scrape day" options={facets?.dates} value={day} onChange={onDayChange} sx={{ minWidth: 160 }} />
      {hasFilter && (
        <Button size="small" onClick={onClear}>
          Clear filters
        </Button>
      )}
    </Box>
  );
}
